import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";
import { BuiltInType } from '@iconics/providers.fadx-platform-api-client-v2';

export class OntologyNode extends ODataSelect
{
    public Name = "";
    public IsEnabled = "";
    public Id = "";
    public IsRecursive = "";
    public Parent_ID = "";
    public Ontology_ID = "";
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}

export class Solution extends ODataSelect
{
    public Id = "";
    public Name = "";
    public DisplayName = "";
    public Description = "";
    public IsEnabled = "";
    public ShowOnHomePage = "";
    public ShowOnMenu = "";
    public ConcurrencyStamp = "";
    public Ontology_ID = "";
    public ImageUri = "";
    public IconUri = "";
    public ApplicationUri = "";
    public OrderSequence = 0;
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}

export class SolutionParameter extends ODataSelect
{
    public Name = "";
    public DisplayName = "";
    public Solution_ID = "";
    public ValueType: BuiltInType = "String";
    public IsEnabled = "";
    public Ontology_ID = "";
    public OntologyNode_ID = "";
    public Id = "";
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}

export class Ontology extends ODataSelect
{
    public Id = '';
    public Name = '';
    public IsEnabled = ''

    public toSelect(): string
    {
        return 'ID,Name,IsEnabled';
    }
}

export interface IPostSolutionResponse
{
    CreatedObject: Solution
}

export interface IPatchSolutionResponse
{
    CreatedObject: Solution
}

export interface ISolutionPackage
{
    Id: string;
    Name: string;
    Description: string;
    IsEnabled: string;
    '@odata.etag': string;
}

export interface IPackage
{
    Id: string;
    Name: string;
    Description: string;
    IsEnabled: string;
    '@odata.etag': string;
}
